import React from 'react';
import { SocketProvider } from './SocketContext';
import { Route } from 'react-router-dom';
import './App.css';
import VideoConferenceModal from './Screen/FaceTalk';
import RoomWithAuth from './Screen/RoomWithAuth';

const Screen = () => {
  return (
    <div>
      <VideoConferenceModal isOpen={true} roomId="some-room-id" />
    </div>
  );
};

function App() {
  return (
    <SocketProvider>
      <div className="App">
        <div id="Contents" className="MasterPanel">
          <Route path="/" exact component={Screen} key="face" />
          <Route path="/room/:roomId" exact component={RoomWithAuth} key="room" />
        </div>
      </div>
    </SocketProvider>
  );
}

export default App;
